import React, { useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { get } from "../services/localStorage";
import { LOGIN, LOG_OUT } from "../constant";
import { isDealerUser } from "../utils/userTypes";
// Default constants
export const DEFAULT_ROUTE = "/dealers";
export const DEFAULT_AUTH_ROUTE = "/login";
export const localStorage_auth = () => {
  const localStorage_auth_data = get({ key: "auth" });
  return localStorage_auth_data
    ? localStorage_auth_data.token
      ? localStorage_auth_data
      : {}
    : {};
};
export let USER = localStorage_auth().token;

function hasDealerAccess(auth) {
  return Boolean(auth?.token) && isDealerUser(auth);
}

// Redux starts empty on a hard refresh and is filled from localStorage in an
// effect, so a stored session means "still restoring", not "logged out".
function isRestoringSession() {
  return hasDealerAccess(localStorage_auth());
}

function redirectTarget(from, fallback) {
  if (!from?.pathname) return { pathname: fallback };
  return {
    pathname: from.pathname,
    search: from.search || "",
    hash: from.hash || "",
  };
}

// ========================== auth route component
export const AuthRoute = (props) => {
  const { children, redirect, path, type, auth, ...rest } = props;

  return (
    <Route
      {...rest}
      render={({ location }) => {
        const from = location.state ? location.state.from : null;
        // Only treat real dealer sessions as logged-in on this portal.
        return !hasDealerAccess(auth) ? (
          children
        ) : (
          <Redirect to={redirectTarget(from, redirect || DEFAULT_ROUTE)} />
        );
      }}
    />
  );
};

// private route component — dealers only
export const PrivateRoute = (props) => {
  const { children, redirect, path, type, auth } = props;
  return (
    <Route
      path={path}
      render={({ location }) => {
        if (hasDealerAccess(auth)) return children;
        if (isRestoringSession()) return null;
        return (
          <Redirect
            to={{
              pathname: redirect ? redirect : DEFAULT_AUTH_ROUTE,
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
};
// public route component

export const PublicRoute = (props) => {
  const { children, redirect, path, type, bool } = props;
  let redirectCondition = bool || false;
  return (
    <Route
      path={path}
      render={({ location }) =>
        !redirectCondition ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: redirect ? redirect : DEFAULT_ROUTE,
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};
